import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Box, InputLabel, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
    customTextEditor: {
        "& .ql-editor": {
            minHeight: "150px"
        }
    }
}));

const CommonTextEditor = ({ value, onChange, label, valid }) => {
    const quillRef = useRef(null);
    const { classes } = useStyles();

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"]
        ]
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const editor = quillRef.current?.getEditor();
            const range = editor?.getSelection();

            if (!editor || !range) return;

            const formats = editor.getFormat(range.index);

            // ✅ If list format is removed, force bullet again
            if (!formats.list) {
                setTimeout(() => {
                    editor.format("list", "bullet");
                }, 0);
            }
        }
    };

    const handleFocus = () => {
        const editor = quillRef.current?.getEditor();
        if (editor && editor.getLength() === 1) {
            editor.format("list", "bullet");
        }
    };

    return (
        <>
            {label && (
                <Box display="flex" gap="2px">
                    <InputLabel>{label}</InputLabel>
                    {valid && (
                        <Typography color="error" component="caption">*</Typography>
                    )}
                </Box>
            )}

            <div onKeyDown={handleKeyDown}>
                <ReactQuill
                    ref={quillRef}
                    value={value}
                    onChange={onChange}
                    onFocus={handleFocus}
                    modules={modules}
                    theme="snow"
                    className={classes.customTextEditor}
                />
            </div>
        </>
    );
};

export default CommonTextEditor;
